module.exports = __webpack_public_path__ + "static/media/web socket managament.cda1f4f0.png";